import {
  ADMIN_CID_ANALYTICS_OVERVIEW_LOADED,
  ADMIN_CID_ANALYTICS_CREATOR_GROWTH_LOADED,
  ADMIN_CID_ANALYTICS_REVENUE_BY_MONTH_LOADED,
  ADMIN_CID_ANALYTICS_REVENUE_RANKS_LOADED,
  ADMIN_CID_ANALYTICS_VIDEO_STATS_LOADED,
  ADMIN_CID_ANALYTICS_WEEKLY_GROWTH_LOADED,
  ADMIN_CID_ANALYTICS_VIEWS_ANALYTICS_LOADED,
  ADMIN_CID_ANALYTICS_CLAIMS_PERFORMANCE_LOADED,
  ADMIN_CID_ANALYTICS_REVENUE_PER_CREATOR_LOADED,
  ADMIN_CID_ANALYTICS_ESTIMATED_REVENUE_LOADED,
  ADMIN_CID_ANALYTICS_FILTER_OPTIONS_LOADED,
  ADMIN_CID_ANALYTICS_YT_AUDITS_LOADED,
  ADMIN_CID_ANALYTICS_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import {
  setFetchLoaderLoading,
  setFetchLoaderReset,
} from '../fetchLoaderActions';
import { arriveNotice } from '../noticeActions';

// --- Reducer actions ---
export function cidAnalyticsOverviewLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_OVERVIEW_LOADED, payload: { data } };
}
export function cidAnalyticsCreatorGrowthLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_CREATOR_GROWTH_LOADED, payload: { data } };
}
export function cidAnalyticsRevenueByMonthLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_REVENUE_BY_MONTH_LOADED, payload: { data } };
}
export function cidAnalyticsRevenueRanksLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_REVENUE_RANKS_LOADED, payload: { data } };
}
export function cidAnalyticsVideoStatsLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_VIDEO_STATS_LOADED, payload: { data } };
}
export function cidAnalyticsWeeklyGrowthLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_WEEKLY_GROWTH_LOADED, payload: { data } };
}
export function cidAnalyticsViewsAnalyticsLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_VIEWS_ANALYTICS_LOADED, payload: { data } };
}
export function cidAnalyticsClaimsPerformanceLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_CLAIMS_PERFORMANCE_LOADED, payload: { data } };
}
export function cidAnalyticsRevenuePerCreatorLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_REVENUE_PER_CREATOR_LOADED, payload: { data } };
}
export function cidAnalyticsEstimatedRevenueLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_ESTIMATED_REVENUE_LOADED, payload: { data } };
}
export function cidAnalyticsFilterOptionsLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_FILTER_OPTIONS_LOADED, payload: { data } };
}
export function cidAnalyticsYtAuditsLoaded(data) {
  return { type: ADMIN_CID_ANALYTICS_YT_AUDITS_LOADED, payload: { data } };
}
export function cidAnalyticsClear() {
  return { type: ADMIN_CID_ANALYTICS_CLEAR };
}

// --- API functions ---
async function fetchOverviewApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'youtube-cid/admin/cid/analytics/overview',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}
async function fetchCreatorGrowthApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'youtube-cid/admin/cid/analytics/creator-growth',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}
async function fetchRevenueByMonthApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'youtube-cid/admin/cid/analytics/revenue-by-month',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}
async function fetchRevenueRanksApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'youtube-cid/admin/cid/analytics/revenue-ranks',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}
async function fetchVideoStatsApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'youtube-cid/admin/cid/analytics/video-stats',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}
async function fetchWeeklyGrowthApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'youtube-cid/admin/cid/analytics/weekly-growth',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}
async function fetchViewsAnalyticsApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'youtube-cid/admin/cid/analytics/views-analytics',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}
async function fetchClaimsPerformanceApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'youtube-cid/admin/cid/analytics/claims-performance',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}
async function fetchRevenuePerCreatorApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'youtube-cid/admin/cid/analytics/revenue-per-creator',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}
async function fetchEstimatedRevenueApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'youtube-cid/admin/cid/analytics/estimated-revenue',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}
async function fetchYtAuditsApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'yt-audit/admin/analytics',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}
async function fetchFilterOptionsApi(token, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'youtube-cid/admin/cid/analytics/filter-options',
    version: 'gateway',
    params: {},
    token,
    dispatch,
    isAdminRoute: true,
  });
  return api.camelizeKeys(await response.json());
}

// --- Public actions ---
export function initiateFetchCidAnalytics(params = {}) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());

      const [
        overview, creatorGrowth, revenueByMonth, revenueRanks, videoStats,
        weeklyGrowth, viewsAnalytics, claimsPerformance,
        revenuePerCreator, estimatedRevenue,
      ] = await Promise.all([
        fetchOverviewApi(adminToken, params, dispatch),
        fetchCreatorGrowthApi(adminToken, params, dispatch),
        fetchRevenueByMonthApi(adminToken, params, dispatch),
        fetchRevenueRanksApi(adminToken, params, dispatch),
        fetchVideoStatsApi(adminToken, params, dispatch),
        fetchWeeklyGrowthApi(adminToken, params, dispatch),
        fetchViewsAnalyticsApi(adminToken, params, dispatch),
        fetchClaimsPerformanceApi(adminToken, params, dispatch),
        fetchRevenuePerCreatorApi(adminToken, params, dispatch),
        fetchEstimatedRevenueApi(adminToken, params, dispatch),
      ]);

      dispatch(cidAnalyticsOverviewLoaded(overview.data));
      dispatch(cidAnalyticsCreatorGrowthLoaded(creatorGrowth.data));
      dispatch(cidAnalyticsRevenueByMonthLoaded(revenueByMonth.data));
      dispatch(cidAnalyticsRevenueRanksLoaded(revenueRanks.data));
      dispatch(cidAnalyticsVideoStatsLoaded(videoStats.data));
      dispatch(cidAnalyticsWeeklyGrowthLoaded(weeklyGrowth.data));
      dispatch(cidAnalyticsViewsAnalyticsLoaded(viewsAnalytics.data));
      dispatch(cidAnalyticsClaimsPerformanceLoaded(claimsPerformance.data));
      dispatch(cidAnalyticsRevenuePerCreatorLoaded(revenuePerCreator.data));
      dispatch(cidAnalyticsEstimatedRevenueLoaded(estimatedRevenue.data));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function initiateFetchYtAudits(params = {}) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());
      const ytAudits = await fetchYtAuditsApi(adminToken, params, dispatch);
      dispatch(cidAnalyticsYtAuditsLoaded(ytAudits.data));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function initiateFetchCidAnalyticsFilterOptions() {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      const result = await fetchFilterOptionsApi(adminToken, dispatch);
      dispatch(cidAnalyticsFilterOptionsLoaded(result.data));
    } catch (e) {
      // non-critical — filter options silently fail
    }
  };
}

export function clearCidAnalytics() {
  return (dispatch) => {
    dispatch(cidAnalyticsClear());
  };
}
